import { isMobileDevice } from '_metronic/assets/ts/_utils'
import clsx from 'clsx'

interface Props {
	active?: boolean
	nameTh: string
	hexColor: string
	onClick?: () => void
	error?: string
}

const KumopackColorPreview: React.FC<Props> = ({ active, nameTh, hexColor, onClick, error }) => {
	const isHexColor = (color: string) => {
		return /^#[0-9A-F]{6}$/i.test(color)
	}

	return (
		<div
			className={clsx('card transition-100 bg-kumopack-grey-50 hover-enabled cursor-pointer', {
				'border border-2px border-kumopack-primary-700': active && !error,
				'border border-1px border-kumopack-grey-200': !active && !error,
				'border-kumopack-error-600': error,
				'w-150px': !isMobileDevice(),
				'w-100': isMobileDevice(),
			})}
			style={{ height: '110px' }}
			onClick={onClick}>
			<div className="card-body p-4">
				<div
					className="mx-auto rounded-circle w-40px h-40px border border-kumopack-grey-500"
					style={{ backgroundColor: isHexColor(hexColor) ? hexColor : 'grey' }}
				/>

				<span className="d-block text-center text-kumopack-grey-500 mt-4">{nameTh}</span>
			</div>
		</div>
	)
}

export default KumopackColorPreview
